import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { finalize } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Constant, NoteCategories, NumberOfEntries, RoleName } from 'src/app/@shared/constants/Constant';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { AppCategoryId } from 'src/app/service/category.model';
import { NoteService } from 'src/app/service/note.service';
import { NotesService } from 'src/app/service/notes.service';
import { ServiceRequestService } from 'src/app/service/service-request.service';
import { VendorService } from 'src/app/service/vendor.service';
import { CreateNote } from 'src/app/shared/interfaces/note.interface';
import { mobileDeviceCheck } from '@helpers/mobile-check.helper';

@Component({
  selector: 'app-note-file-modal',
  templateUrl: './note-file-modal.component.html',
  styleUrls: ['./note-file-modal.component.css'],
})
export class NoteFileModalComponent implements OnInit, OnChanges {
  @Input() files: any = [];
  @Input() businessUnitId: string;
  @Input() fromPage: string;
  @Input() FromPreviewItinerary: boolean;
  @Input() isBadgeVisible: boolean;
  @Input() header: string;
  @Output() changeNotes = new EventEmitter();
  @Output() isCloseModel = new EventEmitter();
  timeZone: any;
  notes: any = [];
  filterCategory: any = [];
  allNotes: any = [];
  mynotes: any = [];
  display: boolean = false;
  noteLoader = false;
  deletingNoteIds = new Set<string>();
  popupFilterFileType: any = [];
  searchText: string;
  editAllFile1: boolean = false;
  isFieldShow: boolean = true;
  sortBy: string = 'createdOn';
  prioritySorting = 'priority';
  searchText1: string = '';
  sortOrder = true;
  recordsForList: number = 5;
  currentPageForList: number = 1;
  totalCount: number;
  N: any;
  R: any;
  responsive: any;
  userBusinessUnitID: any;
  notesPagination: string;
  numberOfEntries = NumberOfEntries;
  categories: AppCategoryId[] = [];
  cDate: boolean = false;
  by: boolean = false;
  category: boolean = false;
  mNotes: boolean = false;

  constructor(
    private toastr: ToastrService,
    private vendorService: VendorService,
    private noteService: NoteService,
    private serviceRequestService: ServiceRequestService,
    private _cdr: ChangeDetectorRef,
    private _notesService: NotesService,
  ) {
    this.serviceRequestService.timZoneChange.subscribe((value) => {
      this.timeZone = Constant.selectedTimeZoneShortValue;
    });
    this.timeZone = Constant.selectedTimeZoneShortValue;
    this._notesService.$fetchNotes.subscribe((type: string) => {
      type === 'Priority' ? this.getNotes() : this.getAllNotes();
    });
  }

  isMobileDevice = true;
  dropdownSettings = {};
  user: ILoggedInUserViewModel;
  isInternalReadOnly: boolean = false;

  ngOnInit(): void {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.isInternalReadOnly = this.user.role === RoleName.InternalReadOnly;
    if (this.user == null) this.user.role = 'OutSideOrg';
    this.fetchAllCategoryList();
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'appCategoryId',
      textField: 'name',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };

    this.isMobileDevice = mobileDeviceCheck();
  }

  ngOnChanges(): void {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.userBusinessUnitID = this.user.businessUnitId;
    this.getNotes();
    this.recordsForList = 5;
    this.currentPageForList = 1;
  }

  selectedCategory: string = '';
  nodeFeedback: string;
  createNoteModel: CreateNote = new CreateNote();

  saveNoteFeedbackData() {
    this.selectedCategory =
      this.fromPage === 'Catering'
        ? this.categories?.find((category) => category.attributeName === NoteCategories.catering)?.appCategoryId
        : this.selectedCategory;
    if (this.nodeFeedback != '' && this.nodeFeedback != undefined && this.selectedCategory != '' && this.selectedCategory != undefined) {
      this.notesOpen = !this.notesOpen;
      this.createNoteModel = {
        category: this.selectedCategory,
        createdBy: this.user.memberId,
        noteDescription: this.nodeFeedback,
        noteType: this.fromPage,
        businessUnitId: this.businessUnitId,
        userBusinessUnitId: this.user.businessUnitId,
        memberId: this.user.memberId,
      };
      this.noteService.createNote(this.createNoteModel).subscribe((response) => {
        this.display = false;
        this.getNotes();
        this.changeNotes.emit();
        this.successMessage('Note Added SuccessFully!');
      });
      this.selectedCategory = '';
      this.nodeFeedback = '';
      this.isFieldShow = false;
    } else {
      this.errorMessage('Fill All Mandatory Field!');
    }
  }
  closeModel() {
    this.notes = [];
    this.isCloseModel.emit();
  }

  getAllNotes() {
    this.noteService.getAllServiceRequestLevelNote(this.businessUnitId, this.userBusinessUnitID).subscribe((response) => {
      this.notes = response;
      this.mynotes = [...this.notes].map((x) => ({ ...x }));
      if (this.FromPreviewItinerary == true) {
        this.mynotes = this.mynotes.filter((a) => a.noteCategory == 'Customer Info');
      }
    });
  }

  successMessage(msg) {
    this.toastr.success(msg, 'Success!', {
      timeOut: 2000,
      positionClass: 'toast-top-center',
    });
  }

  errorMessage(msg) {
    this.toastr.error(msg, 'Error', {
      timeOut: 2000,
      positionClass: 'toast-top-center',
    });
  }

  onApplySubmit() {
    let note = this.allNotes;
    let obj = [];
    if (this.filterCategory.length != 0) {
      note.filter((x) => {
        let index = this.filterCategory.map((y) => y.appCategoryId).indexOf(x.category);
        if (index != -1) {
          obj.push(x);
        }
      });
    } else {
      obj = [...this.allNotes].map((x) => ({ ...x }));
    }
    this.mynotes = obj;
  }

  noteSize(data) {
    if (this.nodeFeedback == '' || this.nodeFeedback == null) {
      this.display = false;
    } else if (data.length > 500) {
      this.display = true;
    } else this.display = false;
  }

  cleanSearchedData() {
    this.filterCategory = '';
    this.getNotes();
  }

  deleteNote(note: any) {
    if (!note?.noteID || this.deletingNoteIds.has(note.noteID)) return;
    this.deletingNoteIds.add(note.noteID);
    this.noteService
      .deleteNotes(note.noteID)
      .pipe(
        finalize(() => {
          this.deletingNoteIds.delete(note.noteID);
          this._cdr.detectChanges();
        }),
      )
      .subscribe({
        next: () => {
          note.isActive = false; // optimistic: keep the button disabled until the re-fetch lands
          this._notesService.$fetchNotes.next('');
        },
        error: () => {
          this.toastr.warning('Something went wrong! Please try again', 'Warning', {
            timeOut: 6000,
            positionClass: 'toast-top-center',
          });
        },
      });
  }

  resetNote() {
    this.display = false;
    this.nodeFeedback = '';
  }

  getNotes() {
    if (this.businessUnitId != null || this.businessUnitId != undefined) {
      this.noteLoader = true;
      this.noteService.getAllServiceRequestLevelNote(this.businessUnitId, this.userBusinessUnitID).subscribe(
        (response) => {
          this.allNotes = response;
          this.mynotes = this.allNotes;
          if (this.FromPreviewItinerary == true) {
            this.mynotes = this.mynotes.filter((a) => a.noteCategory == 'Customer Info');
          }
          this.totalCount = this.mynotes.length;
          this.notesPagination = Constant.showPaginationMessage(this.totalCount, this.currentPageForList, this.recordsForList);
          this.noteLoader = false;
          this._cdr.detectChanges();
        },
        () => {
          this.noteLoader = false;
          this._cdr.detectChanges();
        },
      );
    }
  }

  currentPageChange() {
    this.notesPagination = Constant.showPaginationMessage(this.mynotes.length, this.currentPageForList, this.recordsForList);
  }

  moreFilter: boolean = false;
  notesOpen: boolean = false;

  //sorting method
  sortMe(status) {
    if (status == 'date') {
      this.cDate = !this.cDate;
      this.by = false;
      this.category = false;
      this.mNotes = false;
    } else if (status == 'by') {
      this.by = !this.by;
      this.cDate = false;
      this.category = false;
      this.mNotes = false;
    } else if (status == 'category') {
      this.category = !this.category;
      this.cDate = false;
      this.by = false;
      this.mNotes = false;
    } else if (status == 'mNotes') {
      this.mNotes = !this.mNotes;
      this.category = false;
      this.cDate = false;
      this.by = false;
    }
  }

  fetchAllCategoryList() {
    this.vendorService.getAppCategoryData().subscribe((response) => {
      this.categories = response;
    });
  }

  notePriority(note) {
    let priority;
    if (note.priority != null) {
      priority = note.priority == false ? true : false;
    } else {
      priority = true;
    }
    this.noteService.notePriority(note.noteID, priority).subscribe(
      (response) => {
        this._notesService.$fetchNotes.next('Priority');
        this.successMessage('Note Priority Updated Successfully');
      },
      () => {
        this.toastr.warning('Unable to update the note priority. Please try again.', 'Warning', {
          timeOut: 6000,
          positionClass: 'toast-top-center',
        });
      },
    );
  }

  selectEntriesToShow() {
    this.currentPageForList = 1;
    this.currentPageChange();
  }
}
